// test1579
(1579 && 0);
